"use strict";

define('components/table_settings',['jQuery', 'components/ajax'], function($, ajax) {
    return function TableSettings() {
        var self = this;

        $('[name="selected_table_settings_id"]').on('change', function() {
            var submitUrl = $(this).closest('ul').data('submit-url');
            var formData = new FormData();
            formData.append('selected_table_settings_id', $(this).val());
            ajax(submitUrl, {formData: formData});
        });

        this.initSaveCurrentView = function(modal) {
            modal.attr('data-wide', 'false');

            var select = modal.find('select[name="table_settings_id"]');

            updateView();
            modal.find('input[name="action"]').change(updateView);

            var nameInput = modal.find('input[name="name"]');
            nameInput.change(updateView);
            nameInput.on('input', updateView);
            nameInput.on('focus', function() {
                modal.find('input[name="action"][value="new_view"]').prop('checked', true);
                updateView();
            });

            select.change(updateView);
            select.on('focus', function() {
                modal.find('input[name="action"][value="update_view"]').prop('checked', true);
                updateView();
            });

            function updateView() {
                var action = modal.find('input[name="action"]:checked');
                var readyToSubmit = false;
                
                if (action[0] && action.val() == 'new_view') {
                    readyToSubmit = modal.find('input[name="name"]').val().trim().length > 0;
                } else if (action[0] && action.val() == 'update_view') {
                    var tableSettingsId = select.val();
                    readyToSubmit = /^\d+$/.test(tableSettingsId) && parseInt(tableSettingsId, 10) > 0;
                }

                modal.find('.btn[data-save-url]').toggleClass('disabled', !readyToSubmit);
            }

            var saveButton = modal.find('button[data-save-url]');
            var submitUrl = saveButton.data('save-url');
            saveButton.click(function(e) {
                if (saveButton.hasClass('disabled')) {
                    e.preventDefault();
                    return;
                }

                var formData = new FormData();
                formData.append('action', modal.find('input[name="action"]:checked').val());
                formData.append('name', modal.find('input[name="name"]').val());
                formData.append('table_settings_id', modal.find('select[name="table_settings_id"]').val());

                ajax(submitUrl, {
                    formData: formData,
                    onSuccess: function(result) {
                        modal.modal('hide');
                        $(document).trigger('jsq:modalSuccess', [result]);
                    },
                    onFailure: function(result) {
                        modal.find('.modal-body').html(result.body);
                        self.initSaveCurrentView(modal);
                    }
                });
            });

            setTimeout(function() {
                var action = modal.find('input[name="action"]:checked');
                if (!action[0]) {
                    nameInput.focus();
                }
            }, 500);
        };

        this.initDeleteCurrentView = function(modal) {
            modal.attr('data-wide', 'false');

            var saveButton = modal.find('button[data-save-url]');
            var submitUrl = saveButton.data('save-url');
            saveButton.click(function(e) {
                ajax(submitUrl, {
                    onSuccess: function(result) {
                        modal.modal('hide');
                        $('input[name="selected_table_settings_id"]:checked').closest('li').remove();
                        $('a.table_settings_delete_current_view').addClass('disabled');
                        $('a.table_settings_save_current_view').removeClass('disabled');
                    },
                    onFailure: function(result) {
                        modal.modal('hide');
                    }
                });
            });
        };

        this.initChooseColumns = function(modal) {
            modal.attr('data-wide', 'true');

            configDestList();

            $('.source-group .draggable-item').each(function() {
                // Mark source items as selected if they are selected
                if ($('#selected-' + $(this).attr('id'))[0]) {
                    $(this).find('input[type=checkbox]').prop('checked', true);
                    $(this).addClass('list-group-item-info');
                }
            });

            var destGroup = $('#dest-group');

            destGroup.on('dragenter', function(e) {
                var target = $(e.target).closest('li');
                if (target.attr('draggable') != 'true') return false;

                e.originalEvent.dataTransfer.dropEffect = 'move';
                target.addClass('drag-over');
                stopAutoScroll();
                return false;
            });

            destGroup.on('dragleave', function(e) {
                $(e.target).closest('li').removeClass('drag-over');
            });
            
            destGroup.on('drop', function(e) {
                e.stopPropagation();

                var draggedId = e.originalEvent.dataTransfer.getData('text');

                if (draggedId) {
                    // move the item here
                    var target = $(e.target).closest('li');
                    if (target.attr('draggable') != 'true') return false;

                    var targetId = target.attr('id');

                    if (draggedId.lastIndexOf('selected-', 0) === 0) {
                        // Moving a selected field
                        target.before($('#' + draggedId));
                    } else {
                        if ($('#selected-' + draggedId)[0]) {
                            target.before($('#selected-' + draggedId));
                        } else {
                            insertSourceColumn($('#' + draggedId), target);
                        }
                    }
                    configDestList();
                }

                return false;
            });
            
            destGroup.on('dragover', function(e) {
                var target = $(e.target).closest('li');
                if ((target).attr('draggable') != 'true') return false;

                target.addClass('drag-over');
                e.originalEvent.dataTransfer.dropEffect = 'move';
            });

            $('.source-group .draggable-item').click(function(e) {
                e.preventDefault();
                var checkbox = $(this).find('input[type="checkbox"]');
                checkbox.prop('checked', !checkbox.prop('checked'));
                checkbox.change();
            });

            // Autoscroll when dragging above or below the scroll pane.
            var scrollPane = $('#dest-group').closest('.column_chooser_scroll');
            var scrollAdjustment = 0;
            var autoscrollTimer = null;
            var AUTOSCROLL_DISTANCE_PER_SECOND = 300;
            var AUTOSCROLL_FPS = 20;
            var autoscrollStarted = false;
            function startAutoScroll() {
                if (autoscrollTimer) return;

                function frame() {
                    if (scrollAdjustment != 0) {
                        scrollPane[0].scrollTop += scrollAdjustment / AUTOSCROLL_FPS;
                    } else {
                        stopAutoScroll();
                    }
                }
                autoscrollTimer = setInterval(frame, 1000/AUTOSCROLL_FPS);
                frame();
            }
            function stopAutoScroll() {
                clearInterval(autoscrollTimer);
                autoscrollTimer = null;
                scrollAdjustment = 0;
                autoscrollStarted = false;
            }

            var listGroups = modal.find('.list-group');
            listGroups.on('dragstart', function(e) {
                var target = $(e.target);
                if (target.attr('draggable') != 'true') return false;

                target.addClass('dragging');
                var message = 'Move to end';

                var alreadySelected = !!$('#selected-' + target.attr('id'))[0];
                var draggingFromSourceGroup = target.closest('.source-group')[0];
                var hasSelectedColumns = $('#dest-group .draggable-item').length > 0;
                if (draggingFromSourceGroup && !alreadySelected) {
                    message = hasSelectedColumns ? 'Add to end' : 'Add columns here';
                }
                $('#item-nothing-selected').text(message).show();

                e.originalEvent.dataTransfer.effectAllowed = 'move';
                e.originalEvent.dataTransfer.setData('text', target.attr('id'));

                function measureTopDistanceFromModal(el) {
                    var offsetTop = 0;

                    for (var p = el; p != modal[0]; p = p.offsetParent) {
                        offsetTop += p.offsetTop
                    }

                    return offsetTop;
                }

                $('body').on('dragover.jsqDragColumns', function(mouseEvent) {
                    var mouseY = mouseEvent.originalEvent.clientY;
                    var scrollPaneTop = measureTopDistanceFromModal(scrollPane[0]);
                    if (mouseY < scrollPaneTop) {
                        scrollAdjustment = -AUTOSCROLL_DISTANCE_PER_SECOND;
                    } else if (mouseY > scrollPaneTop + scrollPane.height()) {
                        scrollAdjustment = AUTOSCROLL_DISTANCE_PER_SECOND;
                    } else {
                        scrollAdjustment = 0;
                    }
                    if (scrollAdjustment != 0) {
                        startAutoScroll();
                    }
                });

                startAutoScroll();
                modal.one('jsq:endDrag', function() {
                    stopAutoScroll();
                    $('body').off('dragover.jsqDragColumns');
                });
            });
            
            listGroups.on('dragend', function(e) {
                modal.trigger('jsq:endDrag');

                $('#dest-group .drag-over').removeClass('drag-over');
                $(e.target).removeClass('dragging');
                configDestList();
            });

            var checkboxes = $('.source-group .draggable-item input[type=checkbox]');
            checkboxes.click(function(e) {
                e.stopPropagation();
            });
            checkboxes.change(function(e) {
                var checkbox = $(this);
                var item = checkbox.closest('.draggable-item');

                if (checkbox.is(':checked')) {
                    insertSourceColumn(item, $('#item-nothing-selected'));
                } else {
                    $('#selected-' + item.attr('id')).remove();
                    item.removeClass('list-group-item-info');
                }
                configDestList();
            });

            destGroup.on('click', '.remove-item', function(event) {
                event.preventDefault();

                var selected = $(event.target).closest('.draggable-item');
                var columnId = selected.data('column-id');
                selected.remove();

                var item = $('#source-item-' + columnId);
                item.removeClass('list-group-item-info');

                item.find('input[type="checkbox"]').prop('checked', false);

                configDestList();
            });

            var saveButton = modal.find('button[data-save-url]');
            var submitUrl = saveButton.data('save-url');
            saveButton.click(function(e) {
                var selectedColumns = [];

                $('#dest-group .draggable-item').each(function() {
                    var input = $(this).find('input[name="column_name"]');
                    selectedColumns.push({
                        column_id: $(this).data('column-id'),
                        column_name: input[0] ? input.val() : $(this).data('column-name')
                    });
                });

                var formData = new FormData();
                formData.append('columns', JSON.stringify(selectedColumns));

                saveButton.addClass('disabled').prop('disabled', true);
                ajax(submitUrl, {
                    formData: formData,
                    onSuccess: function(result) {
                        modal.modal('hide');
                        $(document).trigger('jsq:modalSuccess', [result]);
                    },
                    onFailure: function() {
                        saveButton.removeClass('disabled').prop('disabled', false);
                    },
                    onError: function() {
                        saveButton.removeClass('disabled').prop('disabled', false);
                    }
                });
            });

            function insertSourceColumn(sourceItem, destItem) {
                var sourceItemId = sourceItem.attr('id');
                var columnId = sourceItem.data('column-id');
                var columnName = sourceItem.data('column-name');

                var newItem;
                if (/^document_/.test(columnId)) {
                    newItem = $('#selected-document-column-template').clone();
                    newItem.find('.column-original-name').text(columnName);
                } else {
                    newItem = $('#selected-data-column-template').clone();
                    newItem.find('.column-name').text(columnName);
                }

                newItem.attr('id', 'selected-' + sourceItemId);
                newItem.data('column-id', columnId);
                newItem.data('column-name', columnName);

                destItem.before(newItem);
                sourceItem.addClass('list-group-item-info');
                sourceItem.find('input[type="checkbox"]').prop('checked', true);
            }

            function configDestList() {
                if (!$('#dest-group').find('[draggable=true]')[0]) {
                    $('#item-nothing-selected').text('No columns selected').show();
                } else {
                    $('#item-nothing-selected').text('Move to end').hide();
                }
            }
        };
    };
});

